export interface DefaultSuggestion {
  id: string;
  icon: string;
  iconColorClass: string;
  iconBgClass: string;
  titleKey: string;
  descKey: string;
  /** Resolved on click, so the prompt goes out in the language the user is reading. */
  questionKey: string;
}

/** Shown on the start page; the user can switch them off but not delete them. */
export const DEFAULT_SUGGESTIONS: DefaultSuggestion[] = [
  {
    id: 'current_alerts',
    icon: 'notifications_active',
    iconColorClass: 'qa-icon--red',
    iconBgClass: 'qa-badge--red',
    titleKey: 'colimind.quickAction1Title',
    descKey: 'colimind.quickAction1Desc',
    questionKey: 'colimind.quickAction1Question',
  },
  {
    id: 'weekly_cpi_trend',
    icon: 'trending_up',
    iconColorClass: 'qa-icon--blue',
    iconBgClass: 'qa-badge--blue',
    titleKey: 'colimind.quickAction2Title',
    descKey: 'colimind.quickAction2Desc',
    questionKey: 'colimind.quickAction2Question',
  },
  {
    id: 'problematic_colors',
    icon: 'warning',
    iconColorClass: 'qa-icon--amber',
    iconBgClass: 'qa-badge--amber',
    titleKey: 'colimind.quickAction3Title',
    descKey: 'colimind.quickAction3Desc',
    questionKey: 'colimind.quickAction3Question',
  },
];
